import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import useFiltersFromLocation from "src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation";
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { useNavigate } from 'react-router-dom';
import { PivotTable } from "src/mtska-frontend-app-component";

const AdministrationDashboard = React.forwardRef((props, ref) => {

    const showPivotProduzionePerPartner = true;

    const { item: user } = useDataProvider('auth/token');

    const { t } = useTranslation();
    const navigate = useNavigate()

    const [filters, setFilters] = useFiltersFromLocation();


    return (
        <Box ref={ref}>
            {
                showPivotProduzionePerPartner &&
                <PivotTable
                    dataProviderName="statisticsviews/fleet/pivot/views_cars_car"
                    //filters={filters}
                    filters={{
                        items: [
                            {
                                field: "_related_contract_orderTarget_at",
                                operator: "between",
                                value: { from: "2024-01-01", to: "2024-12-31" }
                            }
                        ]
                    }}
                    rows={[
                        { field: '_related_renter_name', sort: 'asc' },
                        { field: '_related_account_area_name', sort: 'asc' },
                        { field: '_related_account_shop_name', sort: 'asc' },
                        { field: '_related_account_name', sort: 'asc' }
                    ]}
                    values={[
                        { field: '_related_contract_production_renter', aggregate: 'sum', format: 'number' }
                    ]}
                    columns={[
                        { field: '_related_contract_orderTarget_at', bucket: 'month' }
                    ]}
                />
            }
        </Box>
    )
})

export default AdministrationDashboard;
